import api from './api';

// Child collections of a marketplace: named modules (Reservation, Housekeeping, ...), API
// documentation links (a URL or a file link), actions, and the ESB attributes an integration is
// composed from. All served by the ui-v2-marketplace admin lambda.
const marketplaceExtrasService = {
  modules: {
    list: async (mpId) => (await api.get(`/admin/marketplace/${mpId}/modules`)).data,
    create: async (mpId, data) => (await api.post(`/admin/marketplace/${mpId}/modules`, data)).data,
    remove: async (mpId, moduleId) => (await api.delete(`/admin/marketplace/${mpId}/modules/${moduleId}`)).data,
  },
  apiDocs: {
    list: async (mpId) => (await api.get(`/admin/marketplace/${mpId}/apidocs`)).data,
    create: async (mpId, data) => (await api.post(`/admin/marketplace/${mpId}/apidocs`, data)).data,
    update: async (mpId, docId, data) => (await api.put(`/admin/marketplace/${mpId}/apidocs/${docId}`, data)).data,
    remove: async (mpId, docId) => (await api.delete(`/admin/marketplace/${mpId}/apidocs/${docId}`)).data,
  },
  actions: {
    list: async (mpId) => (await api.get(`/admin/marketplace/${mpId}/actions`)).data,
    create: async (mpId, data) => (await api.post(`/admin/marketplace/${mpId}/actions`, data)).data,
    update: async (mpId, actionId, data) => (await api.put(`/admin/marketplace/${mpId}/actions/${actionId}`, data)).data,
    remove: async (mpId, actionId) => (await api.delete(`/admin/marketplace/${mpId}/actions/${actionId}`)).data,
  },
  // What this system brings to an integration, read by the ESB screen. `save` both adds and corrects:
  // a row is keyed on its attribute and direction, so the screen never has to know which it is doing.
  esb: {
    list: async (mpId) => (await api.get(`/admin/marketplace/${mpId}/esb`)).data,
    save: async (mpId, data) => (await api.post(`/admin/marketplace/${mpId}/esb`, data)).data,
    remove: async (mpId, attributeId) => (await api.delete(`/admin/marketplace/${mpId}/esb/${attributeId}`)).data,
  },
};

export default marketplaceExtrasService;
